import { render, staticRenderFns } from "./ApexBarChart.vue?vue&type=template&id=51704779"
import script from "./ApexBarChart.vue?vue&type=script&lang=js"
export * from "./ApexBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports